export default __webpack_public_path__ + "static/media/unity.ffa4e316.svg";